export const spacingTypes = {
  NONE: 'None',
  REPLACE: 'Replace Spaces',
  REMOVE: 'Remove Spaces',
} as const
